<template>

<section>
  <!-- days -->
  <div v-for="(item, index) in $store.state.info.scheduleDays" :key="index" class="days">
    <div class="alter" @click="navSwitch(index)">
      <h4>{{ item.date | formatDate(item.dateEnd) }}</h4>
      <h4>{{ item.date | formatWeek(item.dateEnd) }}</h4>
      <i :class="navType[index] && navType[index].show ? 'on' : 'down'" class="iconfont icon-arrowon"></i>
    </div>
    <div v-show="navType[index] && navType[index].show">
      <!-- pre -->
      <ul
        class="schedule daylight"
        v-for='(sch, time) in schsCommon'
        :key="time"
        v-if="checkTime(time, item.date, 'am')">
        <li class="time">{{getTime(time)}}<span></span></li>
        <i></i>
        <li class="item"><h4 v-html="sch"></h4></li>
      </ul>

      <!-- topics todo:判断topic是否存在 -->
      <div v-for="id in item.topics" v-if="topics[id]" :key="id">
        <ul class="is-head">
          <h4>{{topics[id].topic}} </h4>
          <h6>{{topics[id].address}}</h6>
        </ul>
        <ul class="is-subhead odd" v-if="topics[id].speaker.name">
          <li>
            <h2>出品人：<span v-for="(speaker, key) in topics[id].speakers" :key="key">{{ speaker.name }}</span></h2>
            <!--<h2>出品人：<span>{{topics[id].speaker.name}}</span></h2>-->
          </li>
        </ul>
        <!-- lectures -->
        <ul
          v-for="lid in topics[id].sLectureIds"
          :key="lid"
          v-if="lectures[lid] && checkTime(lectures[lid].beginTime, item.date, 'day', lectures[lid].topicId)"
          :class="index%2===0?'schedule':'schedule odd'">
          <!-- todo：判断lecture是否存在 -->
          <li class="time">
            <h5 v-if="checkTraining(lectures[lid].topicId)">
              {{formatTrainingTime(lectures[lid].beginTime, lectures[lid].endTime).day}}
              <br>
              {{formatTrainingTime(lectures[lid].beginTime, lectures[lid].endTime).zone}}
            </h5>
            <h5 v-else>{{lectures[lid].beginTime | formatTime}}</h5>
            <div>
              <a class="iconfont icon-video" v-if="lectures[lid].videoLink" :href="lectures[lid].videoLink" target="_blank">
                <!-- <img src="./assets/video_icon.svg"> -->
              </a>
              <a v-if="!Boolean(lectures[lid].videoStatus)">
                <img src="./assets/video_forbidden.svg">
              </a>
              <a class="iconfont icon-ppt" v-if="Number(lectures[lid].pptStatus)===0&&lectures[lid].pptLink" :href="lectures[lid].pptLink" target="_blank">
                <!-- <img src="./assets/ppt_icon.svg"> -->
              </a>
              <a v-if="Number(lectures[lid].pptStatus)===1">
                <img src="./assets/ppt_forbidden.svg">
              </a>
              <a class="iconfont icon-live_icon" v-if="lectures[lid].hasLive" href="https://time.geekbang.org/">
                <!-- <img src="./assets/live_icon.svg"> -->
              </a>
              <a class="iconfont icon-ppt_inreview" v-if="Number(lectures[lid].pptStatus)===2">
                <!-- <img src="./assets/ppt_inreview.svg"> -->
              </a>
            </div>
          </li>
          <i></i>
          <li class="item">
            <router-link :to="'/presentation/' + lid">
              <h4>{{lectures[lid].title}}</h4>
              <!-- 判断speaker是否存在 -->
              <template v-if="lectures[lid].speakers">
                <p v-for="(speaker, idx) in lectures[lid].speakers" :key="idx">
                  {{speaker.name}}
                  <small>{{speaker.company}}</small>
                  <small v-if="speaker.position"> / </small>
                  <small>{{speaker.position}}</small>
                </p>
              </template>
            </router-link>
          </li>
          <div class="clearfix"></div>
        </ul>
      </div>

      <!-- after -->
      <ul class="is-head">
        <span v-if="item.hasPm">晚场活动</span>
      </ul>
      <ul
        class="schedule night"
        v-for='(sch, time, index) in schsCommon'
        :key="index"
        v-if="checkTime(time, item.date, 'pm')">
          <li class="time">{{getTime(time)}}<span></span></li>
          <i></i>
          <li class="item"><h4 v-html="sch" class="item-content"></h4></li>
      </ul>
    </div>
  </div>
</section>
</template>

<script>
import moment from 'moment'
// import ComH1 from '../com-h1'

export default {
  components: {
    // ComH1
  },
  data: function () {
    let offsetDay = (moment().unix() - moment(this.$store.state.info.beginTime).unix()) / 3600 / 24
    offsetDay = Math.floor(offsetDay)
    if (offsetDay < 0) {
      offsetDay = 0
    } else if (offsetDay > this.$store.state.info.scheduleDays.length - 1) {
      offsetDay = this.$store.state.info.scheduleDays.length - 1
    }

    var navType = []
    this.$store.state.info.scheduleDays.forEach(() => {
      navType.push({ show: false })
    })
    if (navType[offsetDay]) navType[offsetDay].show = true
    return {
      schsCommon: {},
      navType
    }
  },
  computed: {
    topics () {
      return this.$store.state.topics
    },
    lectures () {
      return this.$store.state.lectures
    }
  },
  created: function () {
    this.$store.state.schedules.forEach(schedule => {
      // let time = moment(schedule.beginTime).unix()
      // if (schedule.type === 'common') {
      //   this.schsCommon[time] = schedule.title
      // }
      if (schedule.type === 'common') {
        // let timeDay = moment(schedule.beginTime).format('MM-DD-YYYY')
        let time = moment(schedule.beginTime).unix()
        this.schsCommon[time] = schedule.title
        // 以日期作为健值，构造schsCommon对象
        // if (this.schsCommon[timeDay]) {
        //   this.schsCommon[timeDay][time] = schedule.title
        // } else if (!this.schsCommon[timeDay]) {
        //   this.schsCommon[timeDay] = {}
        //   this.schsCommon[timeDay][time] = schedule.title
        // }
        this.$store.state.info.scheduleDays.forEach((item) => {
          // let infoDate = moment(item.date).format('MM-DD-YYYY')
          // if (timeDay === infoDate) {
          //   item['schsCommon'] = this.schsCommon[infoDate]
          //   item['hasPm'] = false
          //   if (this.checkTime(time, item.date, 'pm')) {
          //     item['hasPm'] = true
          //   }
          // }
          if (item['hasPm'] === undefined) {
            item['hasPm'] = false
          }
          if (!item['hasPm'] && this.checkTime(time, item.date, 'pm')) {
            item['hasPm'] = true
          }
        })
      }
    })
  },
  filters: {
    formatWeek: function (value, valueto) {
      let weeks = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 0: '周日' }
      let m = moment(value).utcOffset('+08:00')
      if (valueto) {
        let m2 = moment(valueto).utcOffset('+08:00')
        return `${weeks[m.day()]}、${weeks[m2.day()]}`
      } else {
        return weeks[m.day()]
      }
    },
    formatDate: function (value, valueto) {
      let m = moment(value)
      if (valueto) {
        let m2 = moment(valueto)
        return m.utcOffset('+08:00').format('YYYY年MM月DD') + '-' + m2.utcOffset('+08:00').format('DD日')
      } else {
        return m.utcOffset('+08:00').format('YYYY年MM月DD日')
      }
    },
    formatTime (time, format = 'HH:mm') {
      return moment(time).utcOffset('+08:00').format(format)
    }
  },
  methods: {
    navSwitch: function (index) {
      if (!this.navType[index]) {
        this.navType.push({ show: false })
      }
      this.navType[index].show = !this.navType[index].show
    },
    /**
     * 判断时间是否在某天的上午或下午
     *
     * @param time 时间
     * @param date 天
     * @param bucket ‘am’, 'pm', 'day'
     * @param topicId 这个议题的所属专题是否是培训
     */
    checkTime (time, date, bucket, topicId) {
      if (String(time).match(/\d{10}/)) {
        time = moment(time * 1000)
      } else {
        time = moment(time)
      }
      let dateBegin = moment(date).utcOffset('+08:00').startOf('day')
      let dateMiddle = dateBegin.clone().add(12, 'h')
      let dateEnd = dateBegin.clone().add(24, 'h')
      // chack if is training
      if (this.checkTraining(topicId)) {
        return true
      }
      //
      if (bucket === 'am') {
        return time.isAfter(dateBegin) && !time.isAfter(dateMiddle)
      } else if (bucket === 'pm') {
        return time.isAfter(dateMiddle) && !time.isAfter(dateEnd)
      } else if (bucket === 'day') {
        return time.isAfter(dateBegin) && !time.isAfter(dateEnd)
      } else {
        return false
      }
    },
    checkTraining (topicId) {
      if (topicId && this.topics[topicId] && Number(this.topics[topicId].typeid) === 3) {
        return true
      }
    },
    // 时间戳转成标准格式
    getTime: function (time) {
      let d = new Date(time * 1000)
      let hour = d.getHours()
      let minutes = d.getMinutes()
      let t = hour + ':' + minutes
      hour = Number(t.split(':')[0])
      minutes = Number(t.split(':')[1])
      return (hour >= 10 ? hour : '0' + hour) + ':' + (minutes >= 10 ? minutes : '0' + minutes)
    },
    formatTrainingTime (timeBegin, timeEnd) {
      timeBegin = moment(timeBegin)
      timeEnd = moment(timeEnd)
      let day = timeBegin.utcOffset('+08:00').format('MM月DD日')
      let dateBegin = timeBegin.clone().utcOffset('+08:00').startOf('day')
      let dateMiddle = dateBegin.clone().add(12, 'h')
      let zone
      if (timeEnd.isBefore(dateMiddle)) {
        zone = '上午'
      } else if (timeBegin.isAfter(dateMiddle)) {
        zone = '下午'
      } else {
        zone = '全天'
      }
      return {
        day,
        zone
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$titlecolor: #3e3a39
$backcolor: #f7f8f8
$borderblue: var(--primary-color)
$bordergray: #b8b8b8
$oddback: #f7f7f7
$litletext: #44403f
$whitetext: #fff

.days:last-child
  border-bottom: 6px solid $borderblue
.alter
  border-top: 6px solid $borderblue
  border-bottom: 1px solid $borderblue
  padding: 22px 0
  text-align: center
  h4
    font-size: 18px
    text-align: center
    margin-top: 8px
    color: #44403f
  .on
    color: var(--primary-color)
    transform: rotateZ(0deg)
  i
    display: block
    margin-top: 8px
    transform: rotateZ(180deg)
    text-align: center
    color: #dedede
  .line
    padding-top: 22px
    border-bottom: 1px solid $bordergray
ul.odd
  background-color: $oddback
ul.is-head
  background-color: $borderblue
  padding: 8px
  text-align: center
  color: $whitetext
  h4
    font-size: 15px
    letter-spacing: 1px
  h6
    margin-top: 2px
    font-size: 12px
ul.is-subhead
  text-align: center
  padding: 8px 0
  font-size: 13px
  color: $borderblue
  span
    display: inline-block
    padding: 0 3px
ul.schedule
  display: flex
  > i
    flex-shrink: 0
    display: flex
    align-items: center
    border-left: 1px solid $borderblue
    &::after
      content: ''
      position: relative
      right: 4px
      display: inline-block
      width: 7px
      height: 7px
      border-radius: 50%
      background-color: $borderblue
  > li
    padding: 10px 0
    display: flex
    flex-direction: column
    justify-content: center
    &.time
      font-size: 13px
      flex-shrink: 0
      width: 20%
      text-align: center
      img
        width: 25%
        margin-top: 2px
      .iconfont
        font-size: 22px
    &.item
      flex-grow: 1
      padding: 10px 20px
      h4
        font-size: 15px
        line-height: 18px
        color: $litletext
      p
        font-size: 13px
        color: $borderblue
        margin-top: 5px
        small
          font-size: 13px
          color: $bordergray
ul
  &.night
    .item
      .item-content
        font-size: 14px
        line-height: 20px
        ::v-deep .title
          display: block
          font-size: 15px
          margin-bottom: 10px
    &:nth-child(2n)
      background-color: $oddback
  &.daylight:nth-child(2n)
  background-color: $oddback
</style>
